import React, { useState, useEffect } from "react";

import {
  Box,
  Slide,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  Button,
  Stack,
  Typography,
  Divider,
} from "@mui/material";
import ConfirmMusicNft from "../ConfirmMusicNft";
import notifier from "../Notifier";
import { useHistory } from "react-router-dom";
import {
  fullName,
  getErrorString,
  getHbar,
  getToken,
  getUsdt,
  getWalletId,
  serialize,
} from "../../constants/function";
import { Images } from "../../assets/common";
import { Close } from "@mui/icons-material";
import ApiService from "../../services/api-service";
import Loader from "../Loader";
import SuccessPopup from "../SuccessPopup";
import BidPopup from "../BidPopup";
import { getBalance } from "../../asyncAction/asyncBalance";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function BuyNow({ open, handleClose, offers, buy, type }) {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = React.useState(false);
  const [openPopup, setOpen] = React.useState(false);
  const [openBid, setOpenBid] = useState(false);
  const [openBuy, setOpenBuy] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [index, setIndex] = React.useState(null);
  const buyNow = async (nftId) => {
    try {
      setIsLoading(true);
      const payload = {
        nftId: nftId,
        currency: "siki",
        type: type,
      };
      const response = await ApiService.BUY_NFT_V2(payload);
      handleClose();
      dispatch(getBalance());
      setIsLoading(false);
    } catch (error) {
      notifier.error(getErrorString(error));
      setIsLoading(false);
    }
  };
  const handleBid = (bidAmount) => {
    if (bidAmount) {
      setOpenBid(false);
      setShowSuccess(true);
      handleClose(bidAmount);
      setIndex(null);
    } else {
      setOpenBid(false);
      setIndex(null);
    }
  };
  const handleBuyed = (bidAmount) => {
    if (bidAmount) {
      setOpenBuy(false);
      setShowSuccess(true);
      handleClose(bidAmount);
      setIndex(null);
    } else {
      setOpenBuy(false);
      setIndex(null);
    }
  };
  const handleOffer = (index) => {
    setIndex(index);
    setOpenBid(true);
  };
  const handleBuy = (index) => {
    setIndex(index);
    setOpenBuy(true);
  };
  return (
    <Box>
      <Dialog
        open={open}
        onBackdropClick={() => handleClose(false)}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => handleClose(false)}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: {
            backgroundColor: "#1E1E1E",
            boxShadow: "none",
            color: "#ffffff",
            borderRadius: 16,

            minWidth: "38%",
          },
        }}
      >
        <Stack
          direction="column"
          sx={{ backgroundColor: "#1E1E1E !important" }}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ padding: "16px" }}
          >
            <Typography className="fs-20">
              {buy ? "All offers" : "Buy Now"}
            </Typography>
            <Close
              className="_cp"
              onClick={() => handleClose(false)}
              color="default"
            />
          </Stack>
          <Divider orientation="horizontal" />
          <Stack sx={{ padding: "16px" }} spacing={1}>
            {offers &&
              offers.map((offer, index) => (
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  key={index}
                >
                  <Stack direction="row" spacing={1}>
                    <img
                      className="avatar"
                      src={offer?.ownerDetails?.profileImg?.filePath || Images.default_user}
                      alt=""
                    />
                    <Stack direction="column">
                      <Typography className="fs-14">
                        {fullName(offer["ownerDetails"])}
                      </Typography>
                      <Typography className="fs-13">
                        NFT’s on {offer?.onSale ? "sale" : "auction"}:{" "}
                        {offer["rank"]}
                      </Typography>
                      {buy ? null : (
                        <Stack
                          direction="row"
                          alignItems="center"
                          spacing={0.5}
                        >
                          <Typography
                            className="fs-12"
                            sx={{ color: "#62FFE1" }}
                          >
                            @
                          </Typography>
                          <img
                            style={{ widht: "20px", height: "20px" }}
                            src={Images.siki_coin}
                            alt="coin"
                          />
                          <Typography
                            className="fs-12"
                            sx={{ color: "#62FFE1" }}
                          >
                            {offer[
                              offer?.onSale ? "sellingPrice" : "highestBid"
                            ].toFixed(1)}
                          </Typography>
                        </Stack>
                      )}
                    </Stack>
                  </Stack>
                  {buy ? null : (
                    <Stack direction="row" alignItems="center" spacing={1}>
                      {offer["onSale"] ? (
                        <Button
                          sx={{ borderColor: "#fff" }}
                          variant="outlined"
                          color="default"
                          disabled={!offer["onSale"]}
                          onClick={() => handleBuy(index)}
                        >
                          Buy
                        </Button>
                      ) : null}
                      {offer["onAuction"] ? (
                        <Button
                          sx={{ borderColor: "#fff" }}
                          variant="outlined"
                          color="default"
                          disabled={!offer["onAuction"]}
                          onClick={() => handleOffer(index)}
                        >
                          Place Bid
                        </Button>
                      ) : null}
                    </Stack>
                  )}
                </Stack>
              ))}
          </Stack>
        </Stack>
        {isLoading ? <Loader wait={true} _class="__loader_inside" /> : null}
        {openBid ? (
          <BidPopup
            isBuy={false}
            highestBid={
              offers[index]["highestBid"] ? offers[index]["highestBid"] : 100
            }
            open={openBid}
            handleClose={(amount) => handleBid(amount)}
            auctionId={offers[index]?.auctionId || 0}
            type={type}
          />
        ) : null}
        {openBuy ? (
          <BidPopup
            isBuy={true}
            highestBid={offers[index]?.sellingPrice}
            open={openBuy}
            handleClose={(amount) => handleBuyed(amount)}
            auctionId={offers[index]?._id}
            type={type}
          />
        ) : null}
        {showSuccess ? (
          <SuccessPopup
            open={showSuccess}
            handleClose={() => setShowSuccess(false)}
            message={t("success.message2")}
          />
        ) : null}
      </Dialog>
    </Box>
  );
}
